var exports = {
  "kL": "xcc377c0b--444273--container",
  "Sl": "xcc377c0b--444273--image",
  "DD": "xcc377c0b--444273--title",
  "h_": "xcc377c0b--444273--description",
};

module.exports = exports;
